import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GroupsProfileComponent } from '../groups-profile/groups-profile.component';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { Contacts } from '../../../model/contacts';
import { GroupsService } from '../../../service/component_dependent/groups.service';
import { Groups } from '../../../model/groups';
import { Data } from '../../../model/data';

@Component({
  selector: 'app-contacts-groups',
  templateUrl: './contacts-groups.component.html',
  styleUrls: ['./contacts-groups.component.scss']
})
export class ContactsGroupsComponent implements OnInit {

  @ViewChild(GroupsProfileComponent) appGroupsProfile: GroupsProfileComponent;

  protected groups: Data[];

  constructor(private groupsService: GroupsService) { }

  ngOnInit() {
    this.initComponents();
  }


  protected openGroupsProfileModal() {
    this.appGroupsProfile.open();
  }

  protected initComponents() {
    this.groups = new Array<Data>();

    this.groupsService.getGroups(null, null, null).subscribe(
      (dataGroups: any) => {
        this.reassignVariablesGroups(dataGroups.data);
      }
    )
  }

  private reassignVariablesGroups(data: any) {
    var length;
    var group: Data;

    length = data.total;

    for(var i = 0; i < length; i++){
      group = new Data();
      group.title = data[i].name;
      group.description = data[i].description;
      group.date = data[i].created_at;
      this.groups.push(group);
    }
  }

}
